import { WEEKDAYS, type PriceZone } from '@ste/shared';
import { t } from '../../i18n/index.ts';

// Prices are EUR/kWh in evcc and the API; people enter and read them in ct/kWh (ADR-0018).

/** EUR/kWh as ct/kWh for an input field, e.g. 0.325 -> "32,5" */
export function toCtInput(euros: number | undefined): string {
  if (euros === undefined) return '';
  return String(Math.round(euros * 10_000) / 100).replace('.', ',');
}

/** "32,5" -> 0.325; undefined for an empty field, NaN for nonsense */
export function parseCt(input: string): number | undefined {
  const text = input.trim();
  if (text === '') return undefined;
  if (!/^\d+([.,]\d*)?$/.test(text)) return Number.NaN;
  return Math.round(Number(text.replace(',', '.')) * 100) / 10_000;
}

export const validPrice = (value: number | undefined, max = 2) =>
  value === undefined || (Number.isFinite(value) && value >= 0 && value <= max);

/** "22:00–06:00 · Mo–Fr" */
export function formatZone(zone: Pick<PriceZone, 'from' | 'to' | 'days'>): string {
  const hours = `${zone.from}–${zone.to}`;
  return zone.days.length === 0 || zone.days.length === 7 ? hours : `${hours} · ${formatDays(zone.days)}`;
}

function formatDays(days: PriceZone['days']): string {
  const index = days.map((d) => WEEKDAYS.indexOf(d)).sort((a, b) => a - b);
  const consecutive = index.every((value, i) => i === 0 || value === index[i - 1]! + 1);
  const label = (i: number) => t(`day.${WEEKDAYS[i]!}`);
  if (consecutive && index.length > 2) return `${label(index[0]!)}–${label(index.at(-1)!)}`;
  return index.map(label).join(', ');
}
